import React from 'react';
export default function getProviderIcon(iconName) {
  switch (iconName) {
    case 'apple':
      return /*#__PURE__*/React.createElement(AppleDarkIcon, null);
    case 'google':
      return /*#__PURE__*/React.createElement(GoogleColorIcon, null);
    case 'facebook':
      return /*#__PURE__*/React.createElement(FacebookColorIcon, null);
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
}
var GoogleColorIcon = function GoogleColorIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": "GoogleColor",
    role: "img",
    "data-test": "google_icon",
    viewBox: "0 0 44 44",
    height: "24",
    width: "24",
    preserveAspectRatio: "xMidYMid meet",
    version: "1.1",
    style: {
      padding: 2
    },
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h44v44H0z",
    role: "presentation",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.511 22.494a25.3 25.3 0 0 0-.4-4.493H22.459v8.509h11.836a10.073 10.073 0 0 1-4.388 6.637v5.526h7.086a21.484 21.484 0 0 0 6.518-16.179Z",
    role: "presentation",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.395 43.992a21.01 21.01 0 0 0 14.56-5.32l-7.112-5.525a13.227 13.227 0 0 1-7.448 2.104 13.098 13.098 0 0 1-12.3-9.038H2.75v5.707a21.947 21.947 0 0 0 19.645 12.072Z",
    role: "presentation",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.094 26.174a12.916 12.916 0 0 1 0-8.354v-5.733H2.75a21.956 21.956 0 0 0 0 19.768l7.344-5.681Z",
    role: "presentation",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.395 8.743a11.899 11.899 0 0 1 8.416 3.292l6.299-6.314A21.126 21.126 0 0 0 22.395.001 21.937 21.937 0 0 0 2.75 12.114l7.344 5.707a13.105 13.105 0 0 1 12.301-9.077Z",
    role: "presentation",
    fill: "#ea4335"
  }));
};
var FacebookColorIcon = function FacebookColorIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": "FacebookColor",
    role: "img",
    "data-test": "facebook_icon",
    viewBox: "0 0 44 44",
    height: "24",
    width: "24",
    style: {
      padding: 2
    },
    preserveAspectRatio: "xMidYMid meet",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h44v44H0z",
    role: "presentation",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 22.134C44 9.91 34.15 0 22 0S0 9.91 0 22.134C0 33.182 8.045 42.34 18.563 44V28.533h-5.586v-6.399h5.585v-4.876c0-5.547 3.285-8.612 8.31-8.612 2.407 0 4.925.433 4.925.433v5.447h-2.774c-2.733 0-3.585 1.706-3.585 3.458v4.15h6.101l-.975 6.399h-5.127V44C35.956 42.34 44 33.182 44 22.134Z",
    role: "presentation",
    fill: "#1877f2"
  }));
};
var AppleDarkIcon = function AppleDarkIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": "AppleDark",
    role: "img",
    "data-test": "apple_icon",
    viewBox: "0 0 44 44",
    height: "24",
    width: "24",
    style: {
      padding: 2
    },
    preserveAspectRatio: "xMidYMid meet",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h44v44H0z",
    role: "presentation",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.475 43.999a5.836 5.836 0 0 0 2.368-.448c.665-.307 1.369-.614 2.111-.909a7.678 7.678 0 0 1 2.803-.448 7.115 7.115 0 0 1 2.751.435l1.997.883a5.925 5.925 0 0 0 2.47.448 4.672 4.672 0 0 0 2.675-.806 9.635 9.635 0 0 0 2.2-2.035c.68-.832 1.28-1.702 1.959-2.56a21.488 21.488 0 0 0 1.715-2.956c.361-.75.682-1.518.96-2.303v-.18l.14-.422.128-.397s-.37-.179-.96-.499a11.302 11.302 0 0 1-2.047-1.51 9.214 9.214 0 0 1-2.01-2.738 9.113 9.113 0 0 1-.857-4.147 9.227 9.227 0 0 1 .678-3.673c.398-.928.933-1.79 1.587-2.56a11.515 11.515 0 0 1 1.638-1.535l.845-.602a9.663 9.663 0 0 0-5.004-3.839 11.085 11.085 0 0 0-2.265-.5c-.653 0-1.139-.089-1.446-.089a9.433 9.433 0 0 0-3.11.5c-.947.345-1.817.678-2.56 1.01a5.258 5.258 0 0 1-2.047.512 5.12 5.12 0 0 1-2.022-.486c-.73-.32-1.536-.64-2.38-.947a7.758 7.758 0 0 0-2.74-.473 10.24 10.24 0 0 0-5.272 1.497 11.225 11.225 0 0 0-4.147 4.402 14.474 14.474 0 0 0-1.625 7.167c0 1.797.21 3.588.627 5.337A28.88 28.88 0 0 0 6.3 34.247a25.337 25.337 0 0 0 2.316 4.197 37.883 37.883 0 0 0 3.213 3.942A4.813 4.813 0 0 0 15.475 44Zm6.975-33.85a6.95 6.95 0 0 0 3.16-.87 8.958 8.958 0 0 0 2.79-2.227 10.687 10.687 0 0 0 1.677-2.854 8.714 8.714 0 0 0 .64-3.302c.006-.3-.015-.6-.064-.896a8.37 8.37 0 0 0-3.48 1.011 9.663 9.663 0 0 0-2.983 2.355 10.572 10.572 0 0 0-1.676 2.649 7.68 7.68 0 0 0-.742 3.289 2.882 2.882 0 0 0 0 .486v.32c.224.03.45.043.678.039Z",
    role: "presentation",
    fill: "#313136"
  }));
};